function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round",
  strokeWidth: 4
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#23C386",
  d: "M26 4.44s-1.5-1.5-6-1.5-7.5 3-12 3-6-1.5-6-1.5v18s1.5 1.5 6 1.5 7.5-3 12-3 6 1.5 6 1.5v-18z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  d: "M26 2.06v33.88"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeLinecap: "round",
  d: "M26 2.06v3.38"
}));

function SvgLeadership(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 36"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyOCAzNiI+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMikiPgogICAgPHBhdGggc3Ryb2tlPSIjMjNDMzg2IiBkPSJNMjQsMi40NCBDMjQsMi40NCAyMi41LDAuOTQgMTgsMC45NCBDMTMuNSwwLjk0IDEwLjUsMy45NCA2LDMuOTQgQzEuNSwzLjk0IDAsMi40NCAwLDIuNDQgTDAsMjAuNDQgQzAsMjAuNDQgMS41LDIxLjk0IDYsMjEuOTQgQzEwLjUsMjEuOTQgMTMuNSwxOC45NCAxOCwxOC45NCBDMjIuNSwxOC45NCAyNCwyMC40NCAyNCwyMC40NCBMMjQsMi40NCBaIi8+CiAgICA8bGluZSB4MT0iMjQiIHgyPSIyNCIgeTE9Ii4wNiIgeTI9IjMzLjk0IiBzdHJva2U9IiMzMzMiLz4KICAgIDxsaW5lIHgxPSIyNCIgeDI9IjI0IiB5MT0iLjA2IiB5Mj0iMy40NCIgc3Ryb2tlPSIjMzMzIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgLeadership as ReactComponent };